/**
 * Converts a string so that every word's first letter is capitalized, remaining letters lowercase.
 * Handles cases where input is in all caps, while preserving vendor acronyms like GRM.
 * @param {string} str
 * @returns {string}
 */
export function capitalizeFirstLetter(str) {
  if (typeof str !== "string" || str.length === 0) return str;

  if (str === "NOT_RESOLVED") return "Not Resolved";

  const trimmed = str.trim();
  const upper = trimmed.toUpperCase();
  if (upper === "GRM") return "GRM";
  if (upper === "ASCELLA") return "Ascella";

  const lowerStr = str.toLowerCase();

  return lowerStr
    .replaceAll("_", " ")
    .split(" ")
    .map((word) => {
      const wUpper = word.toUpperCase();
      if (wUpper === "GRM") return "GRM";
      if (wUpper === "ASCELLA") return "Ascella";
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

/**
 * Formats a vendor name according to brand guidelines.
 * Acronyms like GRM remain all caps ("GRM"), proper names like Ascella use title case ("Ascella").
 * @param {string} val
 * @returns {string}
 */
export function formatVendorName(val) {
  if (!val || typeof val !== "string" || val === "-") return val;
  const upper = val.trim().toUpperCase();
  if (upper === "GRM") return "GRM";
  if (upper === "ASCELLA") return "Ascella";
  if (upper === "SCRIPTCO") return "ScriptCo";
  if (val.trim().length <= 4 && /^[A-Z0-9]+$/i.test(val.trim())) {
    return val.trim().toUpperCase();
  }
  return capitalizeFirstLetter(val);
}
